import React from 'react';
import { ReactComponent as FormErrorSvg } from '../../assets/icons/form-error.svg';
import { Flex, Typography } from 'antd';
import Icon from '@ant-design/icons';
import './CustomFormErrorMessage.css';
import PropTypes from 'prop-types';

const { Text } = Typography;

const CustomFormErrorMessage = ({
  message,
  className = 'form-error-container',
}) => {
  return (
    <Flex gap={10} className={className}>
      <Icon component={FormErrorSvg} style={{ fontSize: '24px' }} />
      <Text>{message}</Text>
    </Flex>
  );
};

CustomFormErrorMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
};

export default React.memo(CustomFormErrorMessage);
